module.exports = __webpack_public_path__ + "img/puentegegro.fb40d739.jpeg";